<template>
 <router-view></router-view>
 <GlobalRequestOverlay />

</template>

<script>
import GlobalRequestOverlay from '@/components/GlobalRequestOverlay.vue';

export default {
  name: 'App',
  components: {
    GlobalRequestOverlay
  }
}
</script>

